import Box from '@material-ui/core/Box'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Link from '@material-ui/core/Link'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React, { useContext } from 'react'
import { TbHome } from 'react-icons/tb'
import { useHistory } from 'react-router-dom'

import SearchInput from '../../../Components/SearchInput'
import colorContext from '../../../Context/colorContext'

interface Props {
  slug: string
}

export default function Breadcrumb({ slug }: Props): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    link: {
      display: 'flex',
    },
    icon: {
      marginRight: theme.spacing(0.5),
      color: theme.palette.primary.main,
      width: 30,
      height: 30,
    },
    inputSearch: {
      height: 50,
      borderRadius: 0,
      width: '100%',
      border: 'none',
      outline: 'none',
      paddingLeft: 16,
      color: colors.textBody,
      background: colors.colorBackground,
      '&::placeholder': {
        color: 'rgba(31, 41, 55, 0.5)',
      },
    },
    buttonSearch: {
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
      },
    },
    breadcrumbs: {
      flexGrow: 1,
      color: theme.palette.primary.main,
    },
    itemBreadcrumb: {
      color: colors.accentColor,
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: '300px',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
    },
    iconSearch: {
      color: '#fff',
    },
  }))
  const classes = useStyles()
  const history = useHistory()
  const matches = useMediaQuery('(min-width:790px)')

  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1320px"
        alignItems={matches ? 'center' : 'initial'}
        width="100%"
        minHeight="56px"
        height="100%"
        justifyContent={matches ? 'flex-end' : 'space-between'}
        padding={matches ? '6px' : '20px'}
        flexDirection={matches ? 'row' : 'column'}
        style={{
          gap: matches ? 0 : 20,
        }}
      >
        <Breadcrumbs separator="/" className={classes.breadcrumbs}>
          <Link
            href="/"
            onClick={(e: React.SyntheticEvent) => {
              e.preventDefault()
              history.push('/')
            }}
          >
            <TbHome className={classes.icon} />
          </Link>
          <Link
            href="/ouvidoria"
            onClick={(e: React.SyntheticEvent) => {
              e.preventDefault()
              history.push('/ouvidoria')
            }}
            className={classes.itemBreadcrumb}
          >
            Ouvidoria
          </Link>
          <Typography className={classes.itemBreadcrumb}>{slug}</Typography>
        </Breadcrumbs>
        <SearchInput placeholder="O que você procura?" />
      </Box>
    </Box>
  )
}
